import styled from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { column } from "v3/styles/checkout/pageLayout.styled";
import { colors } from "@pepdirect/v3/styles/variables";

export const StyledSummaryAndItems = styled.div<{ showBorder?: boolean }>`
  ${column};
  flex-shrink: 0;
  @media ${Device.laptop} {
    width: 360px;
  }
  @media ${Device.notLaptop} {
    margin-top: 20px;
  }
  ${({ showBorder }) =>
    showBorder &&
    `
    border: 1px solid ${colors.gray200};
  `}
`;

export const StyledLoyaltyPointsEarned = styled.div`
  border-radius: 6px;
  padding: 20px;
  background-color: ${colors.gray100};
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  margin-top: 20px;
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 9px;
  height: 15px;
  margin-left: 3px;
`;
